import React, { Fragment, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useMutation } from "react-apollo-hooks";
import {
  GIFT_PRODUCT_PRODUCTOPTION_WRITE_QUERY,
  GIFT_PRODUCT_DETAIL_QUERY,
} from "../../Queries";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { toast } from "react-toastify";

import { commonStatusArray } from "../../../../../Components/User/UserNames";

export default withRouter(
  ({
    history,
    match,
    location,

    isModal,
  }) => {
    const modalRef = React.createRef();

    const [giftProductOptionWriteMutation] = useMutation(
      GIFT_PRODUCT_PRODUCTOPTION_WRITE_QUERY,
      {
        refetchQueries: () => [
          {
            query: GIFT_PRODUCT_DETAIL_QUERY,
            variables: { id: match.params.id },
          },
        ],
      }
    );

    const { register, handleSubmit, errors } = useForm();

    const onSubmit = async (data) => {
      try {
        const {
          data: { AdminGiftProductProductOptionWrite },
        } = await giftProductOptionWriteMutation({
          variables: {
            giftProduct: match.params.id,
            commonStatus: data.commonStatus,
            name: data.name,
            detailCommonStatus: data.detailCommonStatus,
            detailIsSoldOut: data.detailIsSoldOut === "true" ? true : false,
            detailPrice: data.detailPrice,
            detailName: data.detailName,
          },
        });
        if (AdminGiftProductProductOptionWrite) {
          toast.success("처리 되었습니다.");
          history.push(
            `/giftConfigs/${match.params.config}/products/${match.params.id}${location.search}`
          );
        }
      } catch (e) {
        console.log(e);
        var error = e.toString();
        error = error.replace("Error: GraphQL error:", "");
        toast.error(`${error}`);
      }
    };
    // console.log(errors);

    useEffect(() => {
      const element = modalRef.current;

      if (isModal) {
        disableBodyScroll(element);
      }

      return () => {
        enableBodyScroll(element);
      };
    });

    return (
      <Fragment>
        <Modal
          isOpen={true}
          size={"lg"}
          ref={modalRef}
          toggle={() => {
            history.push(
              `/giftConfigs/${match.params.config}/products/${match.params.id}/${location.search}`
            );
          }}
        >
          <form className="margin-bottom-0" onSubmit={handleSubmit(onSubmit)}>
            <ModalHeader
              toggle={() => {
                history.push(
                  `/giftConfigs/${match.params.config}/products/${match.params.id}/${location.search}`
                );
              }}
            >
              상품옵션등록
            </ModalHeader>
            <ModalBody className=" p-0">
              <div className="form-group">
                <div className=" p-10 ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <table className="table table-bordered tablebasic product_op_table">
                          <caption className="sr-only">
                            상품옵션생성-항목,옵션명,옵션상태,상세옵션명,상세옵션가격,상세옵션상태,품절유무
                          </caption>
                          <thead>
                            <tr>
                              <th
                                abbr="옵션명"
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                옵션명
                              </th>
                              <th
                                abbr="옵션상태"
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                옵션상태
                              </th>
                              <th
                                abbr="옵션값"
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                옵션값
                              </th>
                              <th
                                abbr="옵션값 가격"
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                옵션값 가격
                              </th>
                              <th
                                abbr="옵션값 상태"
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                옵션값 상태
                              </th>
                              <th
                                abbr="품절유무"
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                품절유무
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  placeholder="ex) 색상"
                                  ref={register({
                                    required: "옵션명을 입력해주세요.",
                                  })}
                                />
                              </td>
                              <td>
                                <select
                                  className="form-control"
                                  name="commonStatus"
                                  ref={register({
                                    required: "옵션상태를 입력해주세요.",
                                  })}
                                >
                                  <option value="">상태</option>
                                  {Object.keys(commonStatusArray).map(
                                    (key, index) => (
                                      <option key={index} value={key}>
                                        {commonStatusArray[key]}
                                      </option>
                                    )
                                  )}
                                </select>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="detailName"
                                  placeholder="ex) 베이지"
                                  ref={register({
                                    required: "옵션값을 입력해주세요.",
                                  })}
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  type="number"
                                  name="detailPrice"
                                  placeholder="ex) 10000"
                                  ref={register({
                                    required: "옵션값 가격을 입력해주세요.",
                                  })}
                                />
                              </td>
                              <td>
                                <select
                                  className="form-control"
                                  name="detailCommonStatus"
                                  ref={register({
                                    required: "옵션값 상태를 입력해주세요.",
                                  })}
                                >
                                  <option value="">상태</option>
                                  {Object.keys(commonStatusArray).map(
                                    (key, index) => (
                                      <option key={index} value={key}>
                                        {commonStatusArray[key]}
                                      </option>
                                    )
                                  )}
                                </select>
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-control"
                                  name="detailIsSoldOut"
                                  value={true}
                                  ref={register()}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {errors.name && (
                        <Fragment>
                          <span>{errors.name.message}</span>
                          <br />
                        </Fragment>
                      )}
                      {errors.commonStatus && (
                        <Fragment>
                          <span>{errors.commonStatus.message}</span>
                          <br />
                        </Fragment>
                      )}
                      {errors.detailName && (
                        <Fragment>
                          <span>{errors.detailName.message}</span>
                          <br />
                        </Fragment>
                      )}
                      {errors.detailPrice && (
                        <Fragment>
                          <span>{errors.detailPrice.message}</span>
                          <br />
                        </Fragment>
                      )}
                      {errors.detailCommonStatus && (
                        <Fragment>
                          <span>{errors.detailCommonStatus.message}</span>
                          <br />
                        </Fragment>
                      )}
                    </div>
                    <div className="col-sm-12">
                      <div className="text-left text-danger">
                        * 옵션명은 최대 5개까지 등록이 가능합니다.
                        <br />
                        (ex. 옵션명 - 색상 / 사이즈 등)
                        <br />
                        (ex. 옵션값 - 색상 &gt; 화이트 , 블랙 / 사이즈 &gt;
                        240mm, 250mm)
                        <br />
                        <br />* 품절 - 옵션의 품절 여부를 선택합니다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="col-xs-12 text-center">
                <button type="submit" className="btn btn-white text-blue">
                  확인
                </button>
              </div>
            </ModalFooter>
          </form>
        </Modal>
      </Fragment>
    );
  }
);
